export const dashboard = {
	_1: '\'s account page',
	_2: 'Hi, ',
	_3: '! Here you can manage your account, your access token and API usage',
	_4: 'Your API access token',
	_5: 'This token is necessary to use the API',
	_6: 'In order to use the aircheckr API or widget, you need to provide your personal aircheckr access token. You can use this token for all our services and widgets. Read how it works '
};

export const stats = {
	_1: 'API Usage Statistics',
	_2: 'Statistics to date',
	_3: 'Count of API calls this month: ',
	_4: 'of monthly limit',
	_5: 'Your API budget will be renewed on: '
}

export const account = {
	_1: 'Manage Your Account',
	_2: 'Reset Your Password',
	_3: 'To reset your password, please follow the link below: ',
	_4: 'Deactivate Your Account',
	_5: 'If you want to deactivate or delete your account, you can contact us at <a href="mailto:info@aircheckr.com" target="_top">info@aircheckr.com</a>',
	_6: 'Logout'
}

export const Categories = {
  _1: {
      title: 'Aircheckr widget',
      subcategories: [
      {
            key: 0,
            subtitle: 'Integrate the aircheckr widget with ease',
            text: 'You can integrate the aircheckr widget into your website.',
            text_2: '<strong>Step 1</strong>:<br/>Include an HTML5 <code>&lt;article&gt;</code> element in your website with class attribute <code>ac-aircheckr-widget</code>, a <code>data-level</code>, a <code>data-type</code> and a <code>data-token</code> attribute like so:<br><code>&lt;article class="ac-aircheckr-widget" data-level="street" data-type="extended" data-token="[your personal aircheckr access token here]"&gt;&lt;/article&gt;</code>',
            text_3: '<strong>Step 2</strong> (optional):<br/>Add additional data attributes to customize your widget: <code>data-theme</code>, <code>data-locale</code>, <code>data-default-location</code>',
            text_4: '<strong>Step 3</strong>:<br/>Load the aircheckr widget JavaScript file by placing a script tag after your HTML5 <code>&lt;article&gt;</code> element:<br/><code>&lt;script src="https://widget.aircheckr.com/js/client.widget.js"&gt;&lt;/script&gt;</code>',
            text_5: '<a href="https://www.aircheckr.com/contact">Contact us</a> if you need additional help.'
          }
      ]
  },
	_2: {
    	title: 'Manage Your Plan',
    	subcategories: [
			{
        		key: 0,
        		subtitle: 'Current subscription plan: Free',
        		text: 'Your current plan allows you to use up to 1500 API calls per month. Want to update your plan? Reach out to us at <a href="mailto:info@aircheckr.com" target="_top">info@aircheckr.com</a>'
      		}
    	]
	}
}

export const deactivate = {
	_1: 'Are you sure you want to deactivate your account?',
	_2: 'You can\'t undo this step (But you can always create a new account!)',
	_3: 'No, I changed my mind',
	_4: 'Yes, I\'m out'
}

export default dashboard;



// WEBPACK FOOTER //
// ./src/input-text/en/dashboard.js